import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import MarketingPageLayout from '../../common/layout/MarketingPageLayout';
import { getNotFoundPage } from '../../../data/db';
import { openQuoteChat } from '../../../utils/site';
import './notFound.css';

// Netlify rewrites every path to index.html with a 200, so noindex is what keeps unknown URLs out of search results.
const NotFoundPage = () => {
    const page = getNotFoundPage();

    return (
        <>
            <Helmet>
                <title>{page.seo.title}</title>
                <meta name="description" content={page.seo.description} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <MarketingPageLayout pageClassName="not-found-page">
                <section className="not-found">
                    <div className="container">
                        <div className="not-found-eyebrow">{page.eyebrow}</div>
                        <h1 className="not-found-title">{page.title}</h1>
                        <p className="not-found-description">{page.description}</p>
                        <div className="not-found-links">
                            {page.links.map((link) => (
                                <Link key={link.to} to={link.to} className="btn btn-outline">{link.label}</Link>
                            ))}
                            <button type="button" className="btn btn-primary" onClick={openQuoteChat}>Get Quote</button>
                        </div>
                    </div>
                </section>
            </MarketingPageLayout>
        </>
    );
};

export default NotFoundPage;
